import { all, put, takeEvery, call, select } from "redux-saga/effects";
import { MEDIA_ACTIONS, MEDIA_TYPES } from "./actions";
import {
  getMedia as APIgetMedia,
  getAllMedia as APIgetAllMedia,
  createMedia as APIcreateMedia,
  deleteMedia as APIdeleteMedia
} from "../../services/api/media";
import { mediaFilters, mediaLastEvent } from "./selectors";

export function* watchMediaActions() {
  yield all([takeEvery(MEDIA_TYPES.LOAD_ALL_REQUEST, getAllMedia)]);
  yield all([takeEvery(MEDIA_TYPES.LOAD_REQUEST, getMedia)]);
  yield all([takeEvery(MEDIA_TYPES.CREATE_REQUEST, createMedia)]);
  yield all([takeEvery(MEDIA_TYPES.DELETE_REQUEST, deleteMedia)]);
  yield all([takeEvery(MEDIA_TYPES.CREATE_SUCCESS, getAllMedia)]);
  yield all([takeEvery(MEDIA_TYPES.DELETE_SUCCESS, getAllMedia)]);
  yield all([takeEvery(MEDIA_TYPES.UPDATE_FILTERS, getAllMedia)]);
}

function* getMedia(action) {
  try {
    const filters = yield select(mediaFilters);
    const media = yield call(APIgetMedia, filters);
    yield put(MEDIA_ACTIONS.loadSuccess(media));
  } catch (e) {
    yield put(MEDIA_ACTIONS.loadFailure(e));
  }
}

function* getAllMedia(action) {
  let { eventId } = action.payload;
  try {
    if (!eventId) eventId = yield select(mediaLastEvent);
    const filters = yield select(mediaFilters);
    const media = yield call(APIgetAllMedia, eventId, filters);
    yield put(MEDIA_ACTIONS.loadAllSuccess(media));
  } catch (e) {
    yield put(MEDIA_ACTIONS.loadAllFailure(e));
  }
}

function* createMedia(action) {
  const { eventId, file } = action.payload;
  try {
    const media = yield call(APIcreateMedia, eventId, file);
    yield put(MEDIA_ACTIONS.createSuccess(media));
  } catch (e) {
    yield put(MEDIA_ACTIONS.createFailure(e));
  }
}

function* deleteMedia(action) {
  const { eventId, id } = action.payload;
  try {
    const media = yield call(APIdeleteMedia, eventId, id);
    yield put(MEDIA_ACTIONS.deleteSuccess(media));
  } catch (e) {
    yield put(MEDIA_ACTIONS.deleteFailure(e));
  }
}
